var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPanRoof32 = function SvgPanRoof32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 25H8.69a1.59 1.59 0 0 1-.647-.137 1.683 1.683 0 0 1-.548-.391 1.82 1.82 0 0 1-.366-.587A1.92 1.92 0 0 1 7 23.194v-5.58c0-1.754.651-3.435 1.808-4.675C9.965 11.698 11.534 11 13.17 11h5.66c.81 0 1.612.171 2.361.503a6.17 6.17 0 0 1 2.002 1.434 6.664 6.664 0 0 1 1.337 2.145c.31.802.47 1.662.47 2.53v5.578c0 .478-.175.937-.49 1.276-.314.34-.74.531-1.187.534H21",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 29.934V7.809c0-.763.142-1.519.419-2.224A5.842 5.842 0 0 1 8.61 3.7a5.486 5.486 0 0 1 1.784-1.259A5.24 5.24 0 0 1 12.5 2h7.003c1.458 0 2.856.612 3.887 1.702C24.42 4.79 25 6.269 25 7.809V30M7 14.001S4 13.843 4 17h3m18-2.999s3-.158 3 2.999h-3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13 11 23m6-12-6 6m10 8-5 5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 30V12m10 7L11 29m10 1V12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPanRoof32;